import React, { useState, useRef, useEffect } from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';

type CustomerDropProps = {
    fetchCustomers: ({
        statuses,
    }: {
        statuses?: string[];
    }) => void;
};

export function CustomerDrop({ fetchCustomers }: CustomerDropProps) {
    const [selectedType, setSelectedType] = useState<string[]>([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const options = [
        { value: 'sea', label: 'Sea' },
        { value: 'land', label: 'Land' },
        { value: 'air', label: 'Air' },
    ];

    const handleClearStatus = () => {
        setSelectedType([]);
        // setIncludeOutstanding(false);

        fetchCustomers({ statuses: [] });
        // fetchCreditDetails({ includeOutstanding: false }); 
    };

    // Apply filters based on selected statuses and checkbox value
    const handleApplyFilters = () => {
        fetchCustomers({ statuses: selectedType });
        // fetchCreditDetails({ includeOutstanding }); 
    };

    // Toggle dropdown for status selection
    const handleStatusChange = (value: string) => {
        setSelectedType((prev) =>
            prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
        );
    };

    // Remove selected status
    const handleRemoveStatus = (value: string) => {
        setSelectedType((prev) => prev.filter((item) => item !== value));
    };

    // Toggle dropdown visibility
    const toggleDropdown = (e: React.MouseEvent) => {
        e.stopPropagation();
        setDropdownOpen((prev) => !prev);
    };

    // Close dropdown when clicking outside
    const closeDropdown = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', closeDropdown);
        return () => {
            document.removeEventListener('click', closeDropdown);
        };
    }, []);

    return (
        <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true' ref={dropdownRef}>
            <div className='px-7 py-5'>
                <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
            </div>

            <div className='separator border-gray-200'></div>

            <div className='px-7 py-5'>

                <div className="mb-3" onClick={(e) => e.stopPropagation()}>
                    <label className="form-label fw-bold">Status:</label>
                    <div className="custom-select-container position-relative" onClick={toggleDropdown}>
                        <div className="border rounded py-3 px-2" style={{ cursor: 'pointer', backgroundColor: '#F9F9F9' }}>
                            {selectedType.length > 0 ? (
                                selectedType.map((status) => (
                                    <span key={status} className="badge bg-primary me-1">
                                        {options.find((option) => option.value === status)?.label}
                                        <FaTimes
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleRemoveStatus(status);
                                            }}
                                            className="ms-1"
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </span>
                                ))
                            ) : (
                                <span className="text-muted">Select option</span>
                            )}
                        </div>
                        {dropdownOpen && (
                            <ul className="list-group position-absolute mt-1 w-100" style={{ zIndex: '1' }}>
                                {options.map((option) => (
                                    <li
                                        key={option.value}
                                        className={`list-group-item d-flex justify-content-between align-items-center border-0 ${selectedType.includes(option.value) ? 'bg-light text-primary' : ''}`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleStatusChange(option.value);
                                        }}
                                    >
                                        {option.label}
                                        {selectedType.includes(option.value) && <FaCheck />}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                <div className='d-flex justify-content-end'>
                    <button
                        type='reset'
                        className='btn btn-sm btn-white btn-active-light-primary me-2'
                        data-kt-menu-dismiss='true'
                        onClick={handleClearStatus}
                    >
                        Reset
                    </button>

                    <button
                        type='submit'
                        className='btn btn-sm btn-primary'
                        data-kt-menu-dismiss='true'
                        onClick={handleApplyFilters}
                    >
                        Apply
                    </button>
                </div>
            </div>
        </div>
    );
}
